import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "tabIndex", "as", "onClick", "onPress"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themePropType from '../utils/themePropType';
import { interactionPropTypes } from '../utils/types';
import { ON_BRIGHT, DEFAULT, ERROR } from './constants/LinkVariations';
import { useLink } from '@react-aria/link';
import { useRef } from 'react';
import { mergeProps } from '@react-aria/utils';
import { linkTheme } from './theme/linkTheme';
import mergeThemeStyles from '../theme/mergeThemeStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledATag = styled.a.withConfig({
  displayName: "VizExLink__StyledATag",
  componentId: "sc-1aq70bu-0"
})(["", ""], ({
  theme
}) => mergeThemeStyles({
  component: 'Link',
  defaultStyles: linkTheme,
  theme
}));
const VizExLink = _ref => {
  let {
      use = DEFAULT,
      tabIndex = 0,
      as,
      onClick,
      onPress
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ref = useRef(null);
  const {
    linkProps
  } = useLink({
    elementType: as,
    onPress: onPress || onClick
  }, ref);
  return /*#__PURE__*/_jsx(StyledATag, Object.assign({
    as: as,
    ref: ref,
    use: use,
    tabIndex: tabIndex
  }, mergeProps(linkProps, rest)));
};
VizExLink.displayName = 'VizExLink';
VizExLink.propTypes = Object.assign({
  as: PropTypes.oneOf(['a', 'span']),
  children: PropTypes.node,
  external: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  onPress: PropTypes.func,
  theme: themePropType,
  use: PropTypes.oneOf([ON_BRIGHT, DEFAULT, ERROR])
}, interactionPropTypes);
export default VizExLink;